export const GaugeSpeedFastIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M12,2.5A11.5,11.5,0,0,0,.5,14v3.5a1,1,0,0,0,1,1h21a1,1,0,0,0,1-1V14A11.5,11.5,0,0,0,12,2.5Z"
        fill="#00e6ca"
      />
      <path d="M18.665,4.627A11.5,11.5,0,0,0,.5,14v3.5a1,1,0,0,0,1,1H4.792Z" fill="#c4f0eb" />
      <path
        d="M12,2.5A11.5,11.5,0,0,0,.5,14v3.5a1,1,0,0,0,1,1h21a1,1,0,0,0,1-1V14A11.5,11.5,0,0,0,12,2.5Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={12}
        cy={14}
        r={1.5}
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={13.06}
        y1={12.939}
        x2={18.011}
        y2={7.99}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={2.5}
        y1={14.5}
        x2={4.5}
        y2={14.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={21.5}
        y1={14.5}
        x2={19.5}
        y2={14.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={20.776}
        y1={10.365}
        x2={18.929}
        y2={11.13}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={15.635}
        y1={5.223}
        x2={14.87}
        y2={7.071}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={12}
        y1={4.5}
        x2={12}
        y2={6.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={8.365}
        y1={5.223}
        x2={9.13}
        y2={7.071}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={5.283}
        y1={7.282}
        x2={6.695}
        y2={8.697}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={3.224}
        y1={10.365}
        x2={5.07}
        y2={11.13}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
